import React from "react";
import {Box, ListItemButton, ListItemButtonProps} from "@mui/material";
import {styled, alpha} from "@mui/material/styles";

export const StyledListTitle = styled(ListItemButton)<ListItemButtonProps>(({theme}) => ({
  width: 300,
  padding: "4px 14px",
  "& .MuiTypography-root": {
    color: theme.palette.text.primary,
    fontSize: `16px`,
    fontWeight: "500",
    padding: `0`,
  },
  "& > svg": {
    fontSize: "16px",
  },
}));

export const StyledListSubTitle = styled(ListItemButton)<ListItemButtonProps>(({theme}) => ({
  width: 300,
  padding: "4px 0 4px 20px",
  "& .MuiTypography-root": {
    color: theme.palette.text.primary,
    fontSize: `14px`,
    padding: 0,
  },
}));

export const StyledInput = styled(Box)(
  ({theme}) => `
  display:flex;
  align-items: center;
  margin: 20px;
  & label {
    min-width: 120px;
  },
  & input {
    width:250px;
  },
  & > div {
    width:250px;
  },
`
);
export const StyledInputFile = styled(Box)(
  ({theme}) => `
  display:flex;
  align-items: center;
  margin: 0 20px;
  padding:  20px 0;
  border-bottom: 1px solid ${theme.palette.warning.light};
  & label {
    min-width: 150px;
    margin-right: 50px;
  },

  & > p {
    // padding-left: 60px;
  }
  & > button {
    margin-left: auto;
  }
`
);
